<!--corps de navigation-->
<router-outlet></router-outlet>

<!-- barre d'information-->
<information-bar></information-bar>

<!-- barre de navigation des tabs -->
<tab-bar *ngIf="tableMode"></tab-bar>
